<mat-card>
  <app-card-header
    [title]="title"
    icono="departure_board"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (form && !loading()) {
      <form [formGroup]="form" autocomplete="off">
        <section class="inputs-group">
          <!-- Cronograma -->
          <ng-select
            [items]="cronogramas"
            bindLabel="nombre"
            bindValue="_id"
            formControlName="idCronograma"
            placeholder="Cronograma"
            [notFoundText]="'No se encontraron cronogramas'"
            style="width: 100%"
            [multiple]="false"
            [searchable]="true"
            [fixedPlaceholder]="true"
            (change)="cambioCronograma($event)"
            appendTo="body"
          ></ng-select>

          <!-- Hora de salida -->
          <ng-select
            [items]="cronograma?.periodos"
            bindLabel="desde"
            bindValue="desde"
            formControlName="salio"
            placeholder="Hora de salida"
            [notFoundText]="'No se encontraron resultados'"
            style="width: 100%"
            [multiple]="false"
            [searchable]="true"
            [fixedPlaceholder]="true"
            (change)="cambioHoraSalida($event)"
            appendTo="body"
          ></ng-select>
        </section>

        <section class="inputs-group">
          @if (vehiculos) {
            <ng-select
              [items]="vehiculos"
              bindLabel="identificacion"
              bindValue="_id"
              formControlName="idActivo"
              placeholder="Vehículo"
              [notFoundText]="'No hay vehículos creados'"
              style="width: 100%"
              [multiple]="false"
              [searchable]="true"
              [fixedPlaceholder]="true"
              appendTo="body"
            ></ng-select>
          }

          <!-- Chofer -->
          <app-usuario-selector
            style="width: 100%"
            formControlName="idChofer"
            [funciones]="['Chofer']"
            placeholder="Chofer"
            [showCrearBtn]="helper.tienePermiso('Colectivos - Crear choferes')"
          ></app-usuario-selector>
        </section>

        @if (recorridos) {
          <section class="inputs-group">
            <ng-select
              [items]="recorridos"
              bindLabel="nombre"
              bindValue="_id"
              formControlName="idsRecorridos"
              placeholder="Recorridos"
              [notFoundText]="'No hay recorridos creados'"
              style="width: 100%"
              [multiple]="true"
              [closeOnSelect]="false"
              [searchable]="true"
              [fixedPlaceholder]="true"
              appendTo="body"
            ></ng-select>
          </section>
        }

        <section class="inputs-group">
          <mat-checkbox color="primary" formControlName="cancelado">
            Salida cancelada
          </mat-checkbox>
        </section>
      </form>
    }
    @if (loading()) {
      <div class="column-center" style="width: 100%; padding: 24px 0">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="50"
          strokeWidth="5"
        ></mat-progress-spinner>
      </div>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" mat-dialog-close>
      Cancelar
    </button>
    <button
      irxBoton="principal"
      [disabled]="loading() || form.invalid"
      [mat-dialog-close]="true"
      type="button"
      (click)="submit()"
    >
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </mat-card-actions>
</mat-card>
